__turbopack_context__.v({
  "architectureDiagram": "ringStats-module__9779Qq__architectureDiagram",
  "imageGrid": "ringStats-module__9779Qq__imageGrid",
  "logoGrid": "ringStats-module__9779Qq__logoGrid",
  "metaBlock": "ringStats-module__9779Qq__metaBlock",
  "metaGrid": "ringStats-module__9779Qq__metaGrid",
  "metaLabel": "ringStats-module__9779Qq__metaLabel",
  "metaLeft": "ringStats-module__9779Qq__metaLeft",
  "metaOverview": "ringStats-module__9779Qq__metaOverview",
  "metaRight": "ringStats-module__9779Qq__metaRight",
  "metaSection": "ringStats-module__9779Qq__metaSection",
  "metaText": "ringStats-module__9779Qq__metaText",
  "metaTools": "ringStats-module__9779Qq__metaTools",
  "page": "ringStats-module__9779Qq__page",
  "storySection": "ringStats-module__9779Qq__storySection",
});
